<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false" [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">処理ログ</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <label class="caution-color">異常があった為、処理を中断しました</label>
        </div>

        <div class="column-list">
          <label class="list-input-title">正常件数</label>
          <div class="list-input-content">
            <input type="text" style="text-align:right" id="lbl_NormalNum" value="{{kymw0D01Model.normalNum}}" readonly>
          </div>
          <label class="list-input-title">注意件数</label>
          <div class="list-input-content">
            <input type="text" style="text-align:right" id="lbl_AttentionNum" value="{{kymw0D01Model.attentionNum}}" readonly>
          </div>
          <label class="list-input-title">異常件数</label>
          <div class="list-input-content">
            <input type="text" style="text-align:right" id="lbl_AbnormalNum" value="{{kymw0D01Model.abnormalNum}}" readonly>
          </div>
          <label class="list-input-title">ＤＢ更新件数</label>
          <div class="list-input-content">
            <input type="text" style="text-align:right" id="lbl_UpdateNum" value="{{kymw0D01Model.updateNum}}" readonly>
          </div>
          <label class="list-input-title">処理件数</label>
          <div class="list-input-content">
            <input type="text" style="text-align:right" id="lbl_ManageNum" value="{{kymw0D01Model.manageNum}}" readonly>
          </div>
        </div>
      </div>
      <div cdkDragHandle class="drag-subwindow-bottom-area"></div>
    </td>
    <div class="window-title-close">
      <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
      <button id="btn_CloseWindow" forcedEnabledMode="none" (click)="onClickClose()" [tabindex]="0" ></button>
    </div>
  </tr>
</table>
